import React from "react";

export default function SectionHeading({ heading, subHeading, className = "mb-6", dark = false }: { heading: string; subHeading?: string; className?: string; dark?: boolean }) {
  return (
    <>
      <h2 className={`w-11/12 xs:w-full mx-auto text-xl sm:text-2xl lg:text-3xl text-center font-semibold leading-1.3! ${dark ? "text-white" : "text-black"} ${subHeading ? "mb-2" : ""}`}>{heading}</h2>
      <p className={`w-11/12 xs:w-full mx-auto text-center text-sm sm:text-base sm:leading-6 leading-1.5 ${dark ? "text-[#dddddd]" : "text-[#404040]"} ${className}`}>{subHeading}</p>
    </>
  );
}
